import { FieldError } from 'react-hook-form';

export const textFieldErrorMessages: Partial<
  Record<FieldError['type'], string>
> = {
  maxLength: 'Max length exceeded',
  pattern: 'Entered value does not match the required format',
  required: 'This is required',
};
